import WarningText from 'components/text/WarningText';

import styled from 'styled-components';

import { font } from 'asserts/styles/fonts';
import { color } from 'asserts/styles/colors';

const MembershipTicketSkeleton = () => {
  return (
    <>
      <Wrapper>
        {Array.from({ length: 3 }).map((_, index) => (
          <CardWrapper key={index}>
            <section className="one">
              <div></div>
              <div></div>
            </section>
            <section className="two">
              <div></div>
              <div>
                <div></div>
                <div></div>
              </div>
            </section>
            <p></p>
            <div className="three"></div>
            <div className="four"></div>
          </CardWrapper>
        ))}
        <WarningText />
      </Wrapper>
    </>
  );
};

export default MembershipTicketSkeleton;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  flex: 1;

  & > h2 {
    color: ${color.black2};
    ${font.h1_bold};
  }

  & > h3 {
    color: ${color.black2};
    ${font.h2_bold};
  }

  color: ${color.black2};
`;

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 32px;
  border-radius: 16px;
  background: ${color.white};
  box-shadow: 0px 0px 16px 0px ${color.opacityBlack02};

  section.one {
    display: flex;
    flex-direction: column;
    gap: 12px;

    & div:first-of-type {
      width: 360px;
    }

    & > div {
      width: 240px;
      height: 24px;
    }
  }

  section.two {
    display: flex;
    gap: 16px;
    align-items: center;

    & > div:first-of-type {
      width: 40px;
      height: 40px;
    }

    & > div:last-of-type {
      display: flex;
      flex-direction: column;
      gap: 8px;
      background: initial;

      & div:first-of-type {
        width: 320px;
        height: 24px;
      }

      & div:last-of-type {
        width: 480px;
        height: 18px;
      }
    }
  }

  & p {
    height: 1px;
    background: ${color.gray200};
  }

  & div {
    border-radius: 4px;
    background: ${color.gray200};

    &.three {
      display: flex;
      width: 320px;
      height: 20px;
    }

    &.four {
      display: flex;
      width: 100%;
      height: 36px;
      border-radius: 24px;
    }
  }
`;
